import { render } from "./right-button.vue?vue&type=template&id=c5ae3e9a&scoped=true"
const script = {}

import "./right-button.vue?vue&type=style&index=0&id=c5ae3e9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5ae3e9a"]])

export default __exports__